export default {
    namespaced: true,
    state: {
        drawerIsOpened: false,
        // Active persona for accounts that have both an individual and an advisor
        // profile. Persona-pinned pages assert it (advisor pages set 'advisor',
        // the sidebar "View as" switch sets either); shared pages (calculators,
        // onboarding, scenarios, guided planner, …) render the chrome of whichever
        // persona is current. Persisted via the store reducer so it survives
        // reloads and direct navigation.
        viewAs: 'user',
    },
    mutations: {
        setDrawerState(state, isOpen) {
            state.drawerIsOpened = isOpen;
        },
        setViewAs(state, viewAs) {
            state.viewAs = viewAs === 'advisor' ? 'advisor' : 'user';
        },
    },
    getters: {
        isDrawerOpened: state => {
            return state.drawerIsOpened;
        },
        viewAs: state => {
            return state.viewAs;
        },
    },
};
